new Vue({
    el:'#oxChill',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            popup:false, 
            recordPopup:false,
            rankPopup:false,
            invitePopup:false,
            quizPopup:false,
            cardPopup:false,
            loginPopup:false,
            prizePopup:false,
            rulePopup:false,
            sharePopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
                invite_code:'',
                points:0,
                is_win:false,
                invite_num:0,
                is_form:'true'
            },
            submitFlag:false,
            popup1:false,
            select_flag1:0,
            countryArr:[],
            targetTime: new Date('2025-08-31 23:59:59').getTime(),
            countdown: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            isSaving: false,
            className:'',
            prizeName:'',
            // 可抽奖标识
            isLottery:true,
            prizeAll:{
                Apple_AirPods_4:false,
                OXVA_2_piece_Travel_Essential:false,
                OXVA_Crossbody_Bag:false,
                Lucky_Try:false,
            },
            cardimg1:[
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3176_285df5a8-2d20-43ae-b1d0-ace5759ec365.avif?v=1749714445',
                    text:'Beach'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3176.avif?v=1749714445',
                    text:'Forest'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3176_2.avif?v=1749714445',
                    text:'Home'
                }
            ],
            card_active:-1,
            cardimg2:[
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_80c86847-40ce-4a16-b715-5b7a2eace26e.avif?v=1749718789',
                    text:'NeXLIM'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_2b56a6fc-20b9-47ca-a77c-e553db41bb61.avif?v=1749718877',
                    text:'XLIM PRO 2'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_59f95790-522b-4162-9d31-67c7a069b082.avif?v=1749718789',
                    text:'XLIM SQ PRO 2'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_741d0ecf-e149-4830-9474-4fe894e4b15f.avif?v=1749718877',
                    text:'XLIM GO'
                }
            ],
            card_active2:-1,
            cardimg3:[
                [
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry_Raspberry_Mojito.avif?v=1749720734',
                        text:'Strawberry Raspberry Mojito'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Paradise_Punch.avif?v=1749720734',
                        text:'Paradise Punch'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Citrus_Mango_Guava.avif?v=1749720734',
                        text:'Citrus Mango Guava'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pink_Guava.avif?v=1749720734',
                        text:'Pink Guava'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pina_Colada.avif?v=1749720734',
                        text:'Pina Colada'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Cherry_Peach_Lemon.avif?v=1749720734',
                        text:'Cherry Peach Lemon'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pina_Daiquiri.avif?v=1749720734',
                        text:'Pina Daiquiri'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pineapple_Freeze.avif?v=1749720733',
                        text:'Pineapple Freeze'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Triple_Mango.avif?v=1749720733',
                        text:'Triple Mango'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Senorita_e2bce65c-63cb-4f09-9a56-148e19c04e11.avif?v=1749720734',
                        text:'Senorita'
                    }
                ],
                [
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue_Bubble.avif?v=1749721049',
                        text:'Blue Bubble'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue_Sour_Razz.avif?v=1749721049',
                        text:'Blue Sour Razz'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Berries_Burst.avif?v=1749721049',
                        text:'Berries Burst'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Bru_Pop.avif?v=1749721048',
                        text:'Bru Pop'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry_Raspberry_Cherry.avif?v=1749721048',
                        text:'Strawberry Raspberry Cherry'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry_Melon.avif?v=1749721048',
                        text:'Strawberry Melon'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Melon_Banana.avif?v=1749721048',
                        text:'Melon Banana'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Cherry_Fizz.avif?v=1749721048',
                        text:'Cherry Fizz'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue_Razz_Gummy.avif?v=1749721048',
                        text:'Blue Razz Gummy'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Strawberry_Vanilla_Ice_Cream.avif?v=1749721048',
                        text:'Strawberry Vanilla Ice Cream'
                    }
                ],
                [
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blueberry_Pom.avif?v=1749721203',
                        text:'Blueberry Pom'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue_Citrus.avif?v=1749721203',
                        text:'Blue Citrus'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Berry_Lemon.avif?v=1749721203',
                        text:'Berry Lemon'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blackcurrant_Rebena.avif?v=1749721203',
                        text:'Blackcurrant Rebena'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Blue_Mist.avif?v=1749721203',
                        text:'Blue Mist'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Mixed_Grapes.avif?v=1749721203',
                        text:'Mixed Grapes'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Lemon_Lime.avif?v=1749721202',
                        text:'Lemon Lime'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Melon_Berries.avif?v=1749721202',
                        text:'Melon Berries'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Mint_Mix.avif?v=1749721202',
                        text:'Mint Mix'
                    },
                    {
                        img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Pink_Lemon_Bubbly.avif?v=1749721201',
                        text:'Pink Lemon Bubbly'
                    }
                ]
            ],
            card_active3:-1,
            cardimg4:[
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_c201d371-5e30-43cd-9451-aed9bd9340ef.avif?v=1749781914',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_553914cc-e93c-41d4-a6af-50ef5880c9d6.avif?v=1749781915',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_e8e52c20-2113-49dc-92e4-fa0d3a48483f.avif?v=1749781914'
            ],
            card_id1:-1,
            card_id2:-1,
            card_id3:-1,
            isSaving:false,
            pointsLog:{
                Create:0,
                Share:0
            },
            formText:'', 
            rankArr:[],
            coordinatesMap:{
                "Afghanistan": { lat: 33.83927565834697, lng: 65.09736216416461 },
                "Albania": { lat: 41.024424634091616, lng: 19.958566945655623 },
                "Algeria": { lat: 28.178766432547814, lng: 2.192715794250133 },
                "Andorra": { lat: 42.53382914927297, lng: 1.6090788546921515 },
                "Angola": { lat: -12.35003210905848, lng: 17.362323072804394 },
                "Argentina": { lat: -34.86919045781065, lng: -65.4737656853153 },
                "Australia": { lat: -24.971725878951844, lng: 133.68385251346632 },
                "Austria": { lat: 47.626950100251506, lng: 13.973288371852899 },
                "Bahrain": { lat: 26.04686787920158, lng: 50.54633168149423 },
                "Bangladesh": { lat: 24.16780269598887, lng: 90.09870691091467 },
                "Belarus": { lat: 53.1629615498742, lng: 27.930147108395424 },
                "Belgium": { lat: 50.527818189869585, lng: 4.693002258180768 },
                "Bosnia": { lat: 44.60557570421151, lng: 17.79575090283076 },
                "Brazil": { lat: -8.417254793337325, lng: -54.96971129060918 },
                "Bulgaria": { lat: 42.50893355501016, lng: 25.117183192422914 },
                "Burma": { lat: 21.33803099266154, lng: 96.70325125610306 },
                "Canada": { lat: 57.82901652203662, lng: -100.93451892784502 },
                "China": { lat: 35.78670505169326, lng: 103.89820653029776 },
                "Colombia": { lat: 3.411453085711202, lng: -72.56879470196762 },
                "Croatia": { lat: 45.0718264220972, lng: 14.700898956091965 },
                "Czech Republic": { lat: 49.700347441391436, lng: 15.042350667270663 },
                "Ecuador": { lat: -1.530219253447367, lng: -78.13892412622357 },
                "Egypt": { lat: 26.73531045814157, lng: 29.755890754251766 },
                "Fiji": { lat: -17.84937262102206, lng: 177.97436278232922 },
                "France": { lat: 46.610134042496426, lng: 2.4887252458867897 },
                "Ghana": { lat: 7.917945270819787, lng: -1.2656766198354672 },
                "Germany": { lat: 51.05689108729386, lng: 10.60403742935968 },
                "Greece": { lat: 39.46916225685061, lng: 22.498716230043534 },
                "Hungary": { lat: 47.01268572260616, lng: 19.563971132537414 },
                "India": { lat: 22.651469044222633, lng: 79.69806633493408 },
                "Indonesia": { lat: -4.170055862372081, lng: 121.84088200133436 },
                "Iran": { lat: 32.035265244339875, lng: 54.26255635942464 },
                "Iraq": { lat: 33.04707427327386, lng: 42.90731676648433 },
                "Ireland": { lat: 53.51298389848529, lng: -7.944018835815887 },
                "Israel": { lat: 30.967148516792303, lng: 34.85573700430949 },
                "Italy": { lat: 43.02834613125358, lng: 12.570870354738116 },
                "Japan": { lat: 36.51160185641896, lng: 138.4586952628543 },
                "Jordan": { lat: 31.288980705153453, lng: 36.78367698312758 },
                "Kuwait": { lat: 29.338532406725545, lng: 47.33898939585957 },
                "Malaysia": { lat: 3.706546871444533, lng: 102.01536548914555 },
                "Norway": { lat: 61.912742461888364, lng: 9.197031715318495 },
                "Pakistan": { lat: 29.962626187460362, lng: 68.93315703048549 },
                "Palestine": { lat: 31.95462505672411, lng: 35.27678014363002 },
                "Philippines": { lat: 12.487306249631299, lng: 122.97402333688535 },
                "Poland": { lat: 52.92246772545542, lng: 18.649312259163743 },
                "Portugal": { lat: 39.64365545474105, lng: -8.70984650005121 },
                "Russia": { lat: 62.42102908517074, lng: 94.16608784088191 },
                "Saudi Arabia": { lat: 23.688846212660188, lng: 45.49593728432545 },
                "Slovakia": { lat: 48.7064114434496, lng: 19.282458706233164 },
                "South Africa": { lat: -31.022682469675818, lng: 24.082614847612266 },
                "Spain": { lat: 39.458720704249046, lng: -3.8151367303135 },
                "Sweden": { lat: 62.79797699142856, lng: 16.855431682498068 },
                "Turkey": { lat: 38.915695623175644, lng: 35.338412373587445 },
                "Ukraine": { lat: 49.06312533154211, lng: 31.2549770796161 },
                "United Kingdom": { lat: 55.03339882119206, lng: -2.6508658698766197 },
                "United Arab Emirates": { lat: 23.850481738811364, lng: 54.237602601559296 },
                "USA": { lat: 39.32009505545363, lng: -100.29242604132128 },
                "Vietnam": { lat: 14.471425602103798, lng: 108.15385089453683 }
            },
            winners:[],
            pointsHistory:[],
            recordNav:['Points Record','Winning Record'], 
            recordIndex:0,
            quizArr:[
                ['Sports or Outdoor Activities for a Stronger Hit','Traveling or Parties for Thicker Vapor','Feeling Stressed or Down for a Quick Boost','Work Break for a Refreshing Pick-me-up'],
                ['1800mAh Large Battery','Dual Mesh for 2x Flavor Satisfaction','4ml Large Capacity Pod',"Portability & Easy to use"],
                ['Rose Pink','Starry Blue','Silky Purple','Space Gray']
            ],
            quizIndex1:-1,
            quizIndex2:-1,
            quizIndex3:-1,
            cardTitle:['Hola, Sun Chaser!','Hey, Nature Explorer!','Yo, Relax Master!']
        }
    }, 
    methods:{
        // 功能类-------------------------------------------------
        async submitForm(){
            if(!this.checkLogin()) return;
            //是否已经提交过
            if(!JSON.parse(this.user.is_form)) return;
            if(this.quizIndex1==-1 || this.quizIndex2==-1  || this.quizIndex3==-1){
                return showMessage('Please fill in all fields','error');
            }
            if(this.submitFlag) return; //避免重复提交
            this.submitFlag = true
            var str = '1.'+this.quizArr[0][this.quizIndex1] + '; 2.' + this.quizArr[1][this.quizIndex2] + '; 3.' + this.quizArr[2][this.quizIndex3]+'; 4.'+this.formText;
            let params=new URLSearchParams();
            params.append('info',str);
            let res = await axios.post('https://service.oxvatech.cn/oxva/submitForm',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            this.popup = this.quizPopup = this.submitFlag = false //设置为已提交
            this.getInfo() //更新
            if(res.data.status == 200){
                showMessage('Form submitted successfully, Chill Points +10','success')
            }else{
                let errorMessages = {
                    202: 'Already submitted',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        createCombo(){
            if(!this.checkLogin()) return;
            if(this.pointsLog.Create>2) return showMessage('Finished! Try other missions now!','success');
            this.popup = this.cardPopup = true;
            setTimeout(() => {
                new Swiper('.bpc1Swiper', {
                    slidesPerView: 1.5,
                    centeredSlides: true,
                })
        
                new Swiper('.bpc2Swiper', {
                    slidesPerView: 1.5,
                    centeredSlides: true,
                })
        
                new Swiper('.bpc3Swiper', {
                    slidesPerView: 1.5,
                    centeredSlides: true,
                })
            }, 100);
        },
        async watchItem(id,index){
            this[`card_id${id}`] = index;
            if(id==3){
                let params=new URLSearchParams();
                params.append('action','Create');
                let res = await axios.post('https://service.oxvatech.cn/oxva/claimPoints',params,{
                    headers: { Authorization: `${this.user.token}`}
                });
                if(res.data.status==200){
                    this.getInfo() //更新积分记录
                    showMessage('Chill Points +10','success')
                }
            }
        },
        async shareCard(){
            if(this.pointsLog.Share>2) return;
            let params=new URLSearchParams();
            params.append('action','Share');
            let res = await axios.post('https://service.oxvatech.cn/oxva/claimPoints',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.getInfo() //更新积分记录
                showMessage('Chill Points +10','success')
            }
        },
        async lottery(){
            if(!this.checkLogin()) return;
            if(!this.isLottery) return;
            if(this.user.points<10){
                showMessage('Oops! You need more Chill Points. Try some Chill Missions first.','error')
                return;
            }
            // 开始抽奖
            this.isLottery = false
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({name:this.user.name,email:this.user.email}));
            let res = await axios.post('https://service.oxvatech.cn/oxva/lottery',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.status == 200){
                var status = res.data.status
                this.getInfo() //更新积分记录
                if(status==200){
                    //中奖
                    this.prizeName = res.data.data
                    localStorage.setItem('oxChill_prize', this.prizeName) //存储中奖信息;
                    var str = res.data.data.replace(/[ -]/g, '_'); //空格和短横线转为下划线
                    this.prizeAll[str] = true
                    this.user.is_win = true
                    this.Spin()
                    this.getCountry() //更新中奖者
                }else if(status==202){
                    //未中奖
                    this.prizeAll.Lucky_Try = true
                    this.Spin()
                }else{
                    this.isLottery = true
                    let errorMessages = {
                        201: 'Oops! You need more Chill Points.',
                        500:' Server error, please contact customer service',
                    };
                    showMessage(errorMessages[status] || 'Unknown error', 'error');
                }
            }
        },
        // 发送邮箱验证
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/oxva/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        //登录
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/oxva/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_ox_chill_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Good luck with your first spin! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        //用于登录后刷新页面时获取用户信息
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/oxva/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]

                    // if(this.user.name == ''){}

                    //总积分记录
                    this.pointsHistory = res.data.data.arr2
                    if (this.pointsHistory.length > 0) {
                        // 先清空 pointsLog 的计数
                        for (let key in this.pointsLog) {
                          this.pointsLog[key] = 0;
                        }
                      
                        this.pointsHistory.forEach(({ action }) => {
                            // 判断json对象中某个键是否存在
                          if (this.pointsLog.hasOwnProperty(action)) {
                            this.pointsLog[action] += 1;
                          }
                        });
                      }
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
            // 获取国家排名
            let res2 = await axios.get('https://service.oxvatech.cn/oxva/getCountryRanking')
            if(res2.status == 200){
                this.rankArr = res2.data.data.arr1
                //中奖者 
                this.winners = res2.data.data.arr2
            }
        },
        // 控件类-------------------------------------------------
        showPopup(type){
            if(!this.checkLogin()) return;
            if(type=='quizPopup'){
                if(!JSON.parse(this.user.is_form)) return showMessage('Finished! Try other missions now!','success');
            }
            this.popup = this[type] = true;
        },
        checkLogin(){
            // if(!this.isLogin){
            //     this.popup = this.loginPopup = true;
            //     return false;
            // }
            // return true;
            showMessage('The event has ended, thank you for your participation','success');
            return false
        },
        records(){
            if(!this.checkLogin()) return;
            this.popup = this.recordPopup = true;
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        //转动转盘
        Spin(){
            Object.keys(this.prizeAll).forEach((key)=>{
                if(this.prizeAll[key]){
                    //指向哪个奖品停止
                    this.className = key
                }
            })
            setTimeout(()=>{
                //显示奖品
                this.popup = this.prizePopup = true
                //恢复转盘
                this.className = ''
                //可再次抽奖
                this.isLottery=true
            },8300)
        },
        // 工具类-------------------------------------------------
        copyCode(){
            // 复制指定文案到剪贴板
            navigator.clipboard.writeText(this.user.invite_code).then(() => {
                showMessage('Invite code copied successfully','success')
              }).catch(err => {
                showMessage('Invite code copied failed','error')
              });
        },
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        downloadImg() {
            if (this.isSaving) return;
            showMessage('Downloading, please wait. . .','success')
            this.isSaving = true;

            setTimeout(() => {
                const element = $('.bpc_canvas')[0]; // 要保存的DOM元素

                // 使用html2canvas并启用useCORS和allowTaint选项
                html2canvas(element, { 
                    useCORS: true,      // 允许跨域图片
                    allowTaint: false,   // 禁止 taint 跨域图片
                    scale: 3             // 提升清晰度
                }).then(canvas => {
                    // 将canvas转换为图片数据URL
                    const imgData = canvas.toDataURL('image/png');
                    
                    // 创建一个下载链接
                    const link = document.createElement('a');
                    link.href = imgData;
                    link.download = 'Chill-Mate_Combo.png'; // 设置文件名
                    link.click(); // 触发下载
                    this.isSaving = false;
                });
            }, 100);
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        // 活动倒计时
        startTime() {
            this.updateCountdown();
            this.allInterval = setInterval(this.updateCountdown, 1000);
        },
        updateCountdown() {
            var currentTime = new Date().getTime();
            var timeDifference = this.targetTime - currentTime;

            if (timeDifference <= 0) {
                this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
                clearInterval(this.allInterval)
                return;
            }

            var seconds = Math.floor((timeDifference / 1000) % 60);
            var minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
            var hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
            var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

            this.countdown = { days, hours, minutes, seconds };
        },
        getOrdinal(n) {
            if(n>5) return;
            const s = ["th", "st", "nd", "rd"],
                  v = n % 100;
            return s[(v - 20) % 10] || s[v] || s[0];
        }
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        if(this.getCookie('_ox_chill_')){
            this.isLogin = true
            this.user.token = this.getCookie('_ox_chill_')
            //获取用户信息
            //this.getInfo()
            //401--;奖品数据用数组更新;
        }
        if(localStorage.getItem('oxChill_prize')){
            this.prizeName = localStorage.getItem('oxChill_prize')
        }

        //this.startTime();

        //this.getCountry()
    },
    mounted(){
        if(window.innerWidth>750){
            var wFlag = true,box9S=12000,box9P=5
        }else{
            wFlag = false,box9S=8000,box9P=1.5
        }

        const preloadImages = () => {
            for(let i=0;i<this.cardimg4.length;i++){
                const img = new Image();
                img.src = this.cardimg4[i];
            }
        };
        preloadImages()

        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    toggleActions:'play none none reverse',
                }
            })
        }
    
        ScrollTrigger.create({
            trigger:'.box1',
            start:'top top+=15%',
            end:'+=0%',
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>2){
                    $('.box1_move').css({transform:'none'})
                }
            }
        })

        new Swiper('.box2Swiper', {
            loop:true,
            autoplay:true
        })

        showUp('.box2_title')
    
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box2_items .box2_item:nth-child(1)',
                start:'top bottom-=20%',
                end:'+=0%',
                //markers:true,
                animation:gsap.timeline()
                    .from('.box2_items .box2_item:nth-child(-n+2)',{opacity:0,y:'30%',stagger:0.2,duration:1})
            })
            ScrollTrigger.create({
                trigger:'.box2_items .box2_item:nth-child(3)',
                start:'top bottom-=20%',
                end:'+=0%',
                //markers:true,
                animation:gsap.timeline()
                    .from('.box2_items .box2_item:nth-child(n+3):nth-child(-n+5)',{opacity:0,y:'30%',stagger:0.2,duration:1})
            })
        }

        showUp('.box3_tip')
        showUp('.box3_left')
        
        var that = this
        ScrollTrigger.create({
            trigger:'.box3_rotate',
            start:'top bottom-=30%',
            end:'+=0',
            //markers:true,
            onEnter: () => {
                $('.box3_rotate').addClass('box3l_before')
                that.isLottery = false;
                setTimeout(() => {
                    that.isLottery = true;
                }, 3000);
            },
            onLeaveBack: () => {
                // $('.box4l_img').removeClass('box4l_before')
            }
        })

        showUp('.box4_title')
        showUp('.box4_rules')

        ScrollTrigger.create({
            trigger:'.box4_items',
            start:'top bottom-=20%',
            end:'+=0%',
            //markers:true,
            animation:gsap.timeline()
                .from('.box4_items div',{opacity:0,y:'30%',stagger:0.2,duration:1})
        })

        showUp('.box5_title')

        showUp('.box3_subtitle')

        ScrollTrigger.create({
            trigger:'.box6_title',
            start:'top bottom-=20%',
            end:'+=0%',
            //markers:true,
            animation:gsap.timeline()
                .from('.box6_title img',{opacity:0,y:'50%',duration:1})
        })

        //box7
        new Swiper('.box7Swiper', {
            speed:box9S,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                //waitForTransition: false,
            },
            slidesPerView :box9P,
            loop:true
        })
    }
})